jQuery(document).ready(function(){
    setListener();
});
function setListener(){
    jQuery(document).on('click','.soldOutBtn',function(){
      	var form = jQuery(this).parent();
        var email = jQuery('.soldOutForm #email').val();
        var product_id = jQuery('.soldOutForm #product_id').val();
        var product_name = jQuery('.soldOutForm #product_title').val();
        var variation_id = $('.soldOutForm #variation_id').val();
        var variation_name = $('.soldOutForm #variation_title').val();
		axios.post('https://hto.gatocongafas.com/sold_out',{
          			email:email,
          			product_id:product_id,
          			product_name:product_name,
          			variation_id:variation_id,
          			variation_name:variation_name
        		}).then(
              (response) => { 
                if(!response.data.error){
                    //Success
                  $(form).html(response.data.html);

                }
                else if(response.data.msg){
                  $(form).prepend(response.data.msg); 

                }
                
              });
    });
}